module.exports = __webpack_public_path__ + "static/images/jilishipin_76368d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack/jilishipin.png
// module id = 238
// module chunks = 1